export enum SchoolClassType {
  NORMAL = 'N',
  COMPLIMENTARY = 'C',
  TEACHER_TRIAL = 'TT',
  STUDENT_TRIAL = 'ST',
}
